const strings = {
    PATH: {
        ADMIN : '/Yonetim',
        Post : '/yazi',
        Posts : '/yazilar',
    },
    DBTables:{
        POSTS : 'Posts',
        IMAGES : 'Images'
    },
    DateTimeFormat:{
        YYYYMMDD_T_HHmmss:'YYYY-MM-DD[T]HH:mm:ss',
        DDMMYYYY_HHmmss:'DD.MM.YYYY HH:mm:ss',
        DDMMYYYY_HHmm:'DD.MM.YYYY HH:mm',
        HHmmss:'HH:mm:ss',
        HHmm:'HH:mm'
    },
    TimeConverter : {
        HOUR: 'HOUR',
        MINUTE: 'MINUTE',
        SECOND: 'SECOND',
        MILISECOND: 'MILISECOND'
    }
};


const formValues = {
    types: {
        text: 'text',
        number: 'number',
        password:'password'
    },
    labels: {
        warning : 'Dikkat !',
        emptyFields : 'Form Girdilerini Lütfen Kontrol Ediniz !',
        userName: 'Kullanıcı Adı',
        userId: 'Müsteri ID',
        password: 'Şifre',
        email: 'EMail',
        role: 'Kullanıcı Rolü',
        name: 'İsim',
        status: 'Durum',
        oldPassword: 'Eski Şifre',
        newPassword: 'Yeni Şifre',
        ticketId: 'TicketId veya CouponId',
        startDate: 'Başlangıç Tarihi',
        endDate: 'Bitiş Tarihi',
        postTitle: 'Yazı Başlığı',
        postFile: 'Dosya',
    },
    errors: {
        userName: 'Kullanıcı Adı boş olamaz',
        userId: 'Müsteri ID 8 Karakterden oluşmalıdır',
        password: 'Şifre boş olamaz',
        oldPassword: 'Mevcut şifre boş olamaz',
        newPassword: 'Yeni şifre en az 8 Karakterden oluşmalıdır',
        email: 'EMail boş olamaz',
        ticketId: 'TicketId veya CouponId boş olamaz',
        startDate: 'Başlangıç Tarihi boş olamaz',
        endDate: 'Bitiş Tarihi boş olamaz',
        postTitle: 'Yazı Başlığı boş olamaz',
        postFile: 'Dosya boş olamaz',
    }
};

export {strings, formValues}